<script setup lang="ts">
// Single tap = +1 score; double tap = −1 score.
// Uses manual tap-count debounce so the single-tap handler never fires
// on the first tap of a double-tap — circumventing racing between v-click
// and v-click.double firing in the same gesture sequence.

const store = useChallengeWheelStore()

function isInteractive() {
  return store.phase === 'idle' || store.phase === 'playing' || store.phase === 'revealing'
}

const tapTimers: (null | ReturnType<typeof setTimeout>)[] = []
const tapCounts: number[] = []

function handleTap(i: number) {
  if (!isInteractive()) {
    return
  }
  tapCounts[i] = (tapCounts[i] ?? 0) + 1
  if (tapTimers[i]) {
    clearTimeout(tapTimers[i]!)
  }
  tapTimers[i] = setTimeout(() => {
    const count = tapCounts[i] ?? 0
    tapCounts[i] = 0
    tapTimers[i] = null
    if (count >= 2) {
      store.decrementScore(i)
    } else {
      store.incrementScore(i)
    }
  }, 280)
}
</script>

<template>
  <div class="flex flex-col gap-5">
    <div
      v-for="(team, i) in store.teams"
      :key="i"
      v-click="() => handleTap(i)"
      :data-vc-state-active="undefined"
      :style="{ backgroundColor: team.color }"
      :class="[
        'relative flex items-center justify-between rounded-xl px-[1.5vw] py-[0.3vw] shadow-lg',
        'select-none touch-none',
        isInteractive() ? 'cursor-pointer' : 'cursor-default',
        'data-[vc-state-active]:brightness-75',
      ]"
    >
      <span class="min-w-0 flex-1 truncate font-bold text-white drop-shadow" style="font-size: clamp(0.9rem, 2.6vw, 4rem);">{{ team.name }}</span>
      <span class="font-black text-white drop-shadow tabular-nums" style="font-size: clamp(1.4rem, 5vw, 8rem);">{{ team.score }}</span>
    </div>
  </div>
</template>
